import React from 'react';

interface WalletModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConnect: () => void;
}

const WalletModal: React.FC<WalletModalProps> = ({ isOpen, onClose, onConnect }) => {
  if (!isOpen) return null;

  const handleConnect = () => {
    onConnect();
    onClose();
  };

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="wallet-modal-overlay" onClick={handleBackdropClick}>
      <div className="wallet-modal-content">
        <button className="wallet-modal-close" onClick={onClose}>×</button>
        <div className="wallet-modal-header">
          <h2>Connect Your Wallet</h2>
          <p>Connect your Coinbase wallet to access this tier and start playing!</p>
        </div>
        <div className="wallet-modal-body">
          <div className="wallet-benefits">
            <h3>Why connect your wallet?</h3>
            <ul>
              <li>🎮 Access premium game features</li>
              <li>🏆 Track your scores on the leaderboard</li>
              <li>💰 Earn rewards for your achievements</li>
              <li>🔒 Secure and decentralized experience</li>
            </ul>
          </div>
        </div>
        <div className="wallet-modal-footer">
          <button className="wallet-connect-primary" onClick={handleConnect}>
            Connect Coinbase Wallet
          </button>
          <button className="wallet-connect-secondary" onClick={onClose}>
            Maybe Later
          </button>
        </div>
      </div>
    </div>
  );
};

export default WalletModal;